export const BASE_URL = process.env.VUE_APP_API_URL;

export const routes = {
  RESET_PASSWORD: "user/resetPassword",
};
